import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ProductPanel from '../components/ProductPanel';
import { addProduct, getTotals } from '../redux/cartRedux';
import { addFavorite } from '../redux/favRedux';

const Favorite = () => {
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const favorites = useSelector((state) => state.fav);
  const cart = useSelector((state) => state.cart);

  useEffect(() => {
    dispatch(getTotals());
  }, [cart, dispatch]);

  const handleAddCart = (product, color, size) => {
    const { desc, categories, ...item } = product;
    dispatch(addProduct({ ...item, quantity, color, size }));
  };

  const handleAddFav = (product, color, size) => {
    const { desc, categories, ...item } = product;
    dispatch(addFavorite({ ...item, quantity, color, size }));
  };

  return (
    <div className="py-16">
      <div className="tw-container min-h-full">
        <div>
          <h2 className="text-center font-bold text-3xl lg:text-4xl">Your Wishlist</h2>
          <div className="mt-3 w-24 h-1 bg-blue-400 mx-auto" />
        </div>
        {favorites.products.length !== 0 ? (
          <>
            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
              {favorites.products?.map((product) => (
                <ProductPanel
                  key={product._id}
                  product={product}
                  handleAddFav={handleAddFav}
                  handleAddCart={handleAddCart}
                />
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="h-96 text-center grid place-items-center">
              <div>
                <h1 className="text-7xl ">No Wishlist</h1>
                <Link to="/products" className="btn my-8 mx-auto text-xl capitalize">
                  Add Products
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default Favorite;
